// extracted by mini-css-extract-plugin
export default {"Subject__container":"SubjectChange_Subject__container__iefsU","IonPopover":"SubjectChange_IonPopover__1YwhW","Subject_Choice__hr":"SubjectChange_Subject_Choice__hr__Hyg3w"};